/** Helpers for sending users to the in-app Radius map with a destination preloaded. */
import { dashboardPath } from "@/lib/dashboardPaths";

export interface DirectionsTarget {
  name: string;
  lat?: number | null;
  lng?: number | null;
  /** Verified street address — used when no coordinates are stored. */
  address?: string | null;
}

export function hasDestination(t: DirectionsTarget) {
  return (t.lat != null && t.lng != null) || Boolean(t.address?.trim());
}

/** `/dashboard/<role>/radius?destName=…` — the radius page builds the route from these. */
export function radiusDirectionsPath(t: DirectionsTarget, pathname = window.location.pathname): string {
  const params = new URLSearchParams();
  params.set("destName", t.name);
  if (t.lat != null && t.lng != null) {
    params.set("destLat", String(t.lat));
    params.set("destLng", String(t.lng));
  }
  if (t.address) params.set("destAddress", t.address);
  return `${dashboardPath("radius", pathname)}?${params.toString()}`;
}

export interface RouteStep {
  instruction: string;
  distance: string;
  duration: string;
}

/** Strips Google's HTML instructions down to readable turn-by-turn text. */
export function toRouteSteps(leg: google.maps.DirectionsLeg | undefined): RouteStep[] {
  return (leg?.steps ?? []).map((s) => ({
    instruction: (s.instructions ?? "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim(),
    distance: s.distance?.text ?? "",
    duration: s.duration?.text ?? "",
  }));
}
